const PROFILE = {
  UPDATED: 'Profile updated.',
} as const;

export default PROFILE;
